import { api } from '@smena/ui';

export interface AttentionItem {
  type: 'escalation' | 'draft';
  id: string;
  sid: string | null;
  channelRef: string | null;
  createdAt: string;
  title: string;
  body: string;
  /** Ключ клиента для навигации на `/dialogs/:clientKey`. */
  clientKey: string | null;
  meta?: { suggestedReply?: string | null; rawReason?: string };
}

export interface AttentionCounts {
  escalations: number;
  drafts: number;
  total: number;
}

export async function fetchAttention(): Promise<{ items: AttentionItem[]; counts: AttentionCounts }> {
  return api('/api/staff/attention');
}

export async function closeEscalation(id: string): Promise<void> {
  await api(`/api/staff/escalations/${id}/close`, { method: 'POST', json: {} });
}

export async function approveDraft(id: string): Promise<void> {
  await api(`/api/staff/drafts/${id}/approve`, { method: 'POST', json: {} });
}

export async function editDraft(id: string, text: string): Promise<void> {
  await api(`/api/staff/drafts/${id}/edit`, { method: 'POST', json: { text } });
}

export async function rejectDraft(id: string): Promise<void> {
  await api(`/api/staff/drafts/${id}/reject`, { method: 'POST', json: {} });
}
